import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useGetBanksErrors = () => {
  const context = useAuthContext('employee_registrations:read');
  const client = useApolloClient();
  const query = useCallback(
    email =>
      client
        .query({
          query: Queries.getBanksErrors,
          variables: { email },
          fetchPolicy: 'network-only',
          context,
        })
        .then(response => ({
          banks: response.data.getUserBanks,
          errors: response.data.getPlaidErrors,
        })),
    [client, context],
  );
  return query;
};

export default useGetBanksErrors;
